module.exports = __webpack_public_path__ + "img/13.5b13f1f1.svg";